import React, { Component } from "react";

import PastoralCareImg from "../../assets/images/ministries/PastoralCare.jpg";

class PastoralCare extends Component {
	render() {
		return (
			<section>
				<header id="page-title">
					<div className="container">
						<h1>Pastoral Care</h1>
					</div>
				</header>
				<section className="container">
					<img src={PastoralCareImg} style={{ float: "right" }} alt="" />
					<p>
						Pastoral care at CRCK happens primarily through our Connect Groups. However, for those who are especially
						old or needy and so can’t be part of a Connect Group, we care for them through our ‘Pastoral Care Partners’
						team, who conduct regular home visits. If you would like to find out more about how you can get involved in
						this ministry, or are in need of it yourself, please call the office or email{" "}
						<a href="mailto:pastoralcare@kingstoncrc.org.au">pastoralcare@kingstoncrc.org.au</a>
					</p>
				</section>
			</section>
		);
	}
}

export default PastoralCare;
